"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPLIT = void 0;
const tab_1 = require("../../../tab");
exports.SPLIT = {
    description: 'Splits the @text by the specified @separator and returns the text found on @position',
    arg_names: ['text', 'separator', 'position'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['number'],
            required: true,
        },
    ],
    args_description: [
        'text to split',
        'separator character',
        'position to return. first position (0) by default',
    ],
    return_type: tab_1.ColumnType.STRING,
};
